import uiEn from '@sparklayer-io/spark-dash-ui/i18n/en';
import components from './components';
import features from './features';
import notifications from './notifications.json' with { type: 'json' };
import pages from './pages';

export default {
  ...uiEn,
  components,
  features,
  notifications,
  pages,
};
